import React, { Component } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core styles
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional theme
import "../ag-theme-ela.css";
import { currencyCellRenderer } from "../utils/Common";

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: "1px solid #ccc", // Adds a light gray divider
  },
};

export const columns = [
  { headerName: "Job Date", field: "jobDate", width: 80 },
  { headerName: "ABBRV", field: "clientAbbrv", width: 80 },
  { headerName: "Month", field: "month", width: 80 },
  { headerName: "Job Total", field: "jobTotal", width: 80, cellRenderer: currencyCellRenderer },
  { headerName: "CLAIMANT", field: "clmClaimNumber", width: 100 },
  { headerName: "LAST NAME", field: "clmLastName", width: 120 },
  { headerName: "FIRST NAME", field: "clmFirstName", width: 120 },
  { headerName: "Examiner", field: "examiner", width: 120 },
  { headerName: "LANGUAGE", field: "clmLanguage", width: 80 },
  { headerName: "EMPLOYER", field: "clmEmployer", width: 100 },
  { headerName: "Provider", field: "provider", width: 100 },
  { headerName: "Job Notes", field: "invoiceNote", width: 400 },
  { headerName: "Apt State", field: "aptState", width: 50 },
  { headerName: "Job Num", field: "jobNum", width: 80 },
  { headerName: "Client Name", field: "clientName", width: 150 },
  { headerName: "Job Balance", field: "jobBalance", width: 150, cellRenderer: currencyCellRenderer },
  { headerName: "Insured", field: "clmInsuredParty", width: 150 },
];

export class RptClientSummaryTableDefault extends Component {
  static displayName = RptClientSummaryTableDefault.name;

  constructor(props) {
    super(props);
    this.state = {
      columnWidths: columns.reduce((acc, col) => {
        acc[col.field] = col.width || DEFAULT_MIN_WIDTH_CELL; // Initialize widths
        return acc;
      }, {}),
      isResizing: -1,
      clickCount: 0,
    };
    this.previousSelection = [];
    // Bind methods
    this.onColumnResized = this.onColumnResized.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  autoSizeUnspecifiedColumns = () => {
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      // Check if the width is not set in the column definition
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        ".ag-header-cell-text"
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        // Ensure that you have access to the clientHeight property correctly
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });

      // Adding some padding or extra space if necessary
      maxHeight += 10; // Adjust this value based on your CSS and padding needs

      // Directly set the new header height
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ gridApiReady: true });
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns(false);
  };

  onDataLoaded = (newData) => {
    this.gridApi.setRowData(newData);
    this.autoSizeUnspecifiedColumns(true);
  };

  onColumnResized = (params) => {
    if (params.finished) {
      // Update the state with new column width
      const newWidths = { ...this.state.columnWidths };
      params.columns.forEach((column) => {
        newWidths[column.getColId()] = column.getActualWidth();
      });
      this.setState({ columnWidths: newWidths }, () => {
        // Call adjustHeaderHeight after state update to ensure it uses the latest widths
        this.adjustHeaderHeight(this.gridApi);
      });
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: columns,
      rowData: this.props.rptClientSummary,
      context: {
        componentParent: this,
        gridApi: this.gridApi,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      components: {},
      onColumnResized: this.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: "100%",
          height: "600px",
        }}
      >
        <AgGridReact
          {...gridOptions}
          onGridReady={this.onGridReady}
          rowSelection={"multiple"}
        />
      </div>
    );
  }
}
